import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Navbar from "../components/Navbar";
import { motion, useAnimation } from "framer-motion";
import Footer from "../components/Footer";

const TransparentCard = ({ image, title, index, onImageClick }) => {
  const controls = useAnimation();

  useEffect(() => {
    controls.start({
      opacity: [0, 1],
      y: [50, 0],
      transition: {
        delay: index * 0.15,
        duration: 0.8,
        type: "spring",
        stiffness: 60
      }
    });
  }, [controls, index]);

  return (
    <motion.div
      animate={controls}
      initial={{ opacity: 0, y: 50 }}
      onClick={() => onImageClick(image)}
      className="cursor-pointer bg-white/50 backdrop-blur-sm border rounded-lg shadow-lg overflow-hidden transition duration-300 hover:bg-white/90"
    >
      <img
        src={image}
        alt={title}
        className="w-full h-64 object-cover"
      />
      <p className="p-4 text-center font-semibold text-black/90">{title}</p>
    </motion.div>
  );
};

const Drawings = () => {
  const { t } = useTranslation();
  const [selectedImage, setSelectedImage] = useState(null);

  const drawings = [
    { id: 1, file: "Drawing1.jpg", titleKey: "drawings.image1.title" },
    { id: 2, file: "Drawing2.jpg", titleKey: "drawings.image2.title" },
    { id: 3, file: "Drawing3.jpg", titleKey: "drawings.image3.title" },
    { id: 4, file: "Drawing4.jpg", titleKey: "drawings.image4.title" },
    { id: 5, file: "Drawing5.jpg", titleKey: "drawings.image5.title" },
    { id: 6, file: "Drawing6.jpg", titleKey: "drawings.image6.title" },

  ];

  return (
    <div className="flex flex-col min-h-screen bg-cover bg-center" style={{ backgroundImage: "url('/assets/drawings_bg.png')" }}>
      <Navbar className="bg-black/60 backdrop-blur-md fixed top-0 w-full z-50" />

      <div className="flex-grow pt-28 px-4 pb-12 max-w-screen-lg mx-auto">
        <h1 className="text-4xl font-bold mb-8 text-center text-white drop-shadow-lg">
          {t("drawings.title")}
        </h1>

        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {drawings.map((img, i) => (
            <TransparentCard
              key={img.id}
              index={i}
              image={`/documents/drawings/${img.file}`}
              title={t(img.titleKey)}
              onImageClick={(imgPath) => setSelectedImage(imgPath)}
            />
          ))}
        </div>
      </div>

      {selectedImage && (
        <div
          onClick={() => setSelectedImage(null)}
          className="fixed inset-0 bg-black/70 flex items-center justify-center z-50"
        >
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-4 right-4 text-white text-3xl font-bold z-50 hover:text-red-400 transition"
          >
            &times;
          </button>
          <motion.img
            src={selectedImage}
            alt="Zoomed"
            className="max-w-full max-h-[90vh] rounded-md shadow-2xl"
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
          />
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Drawings;
